"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("webapp-genric/dist/super-table/model/table/types");
const react_1 = __importStar(require("react"));
const actionContext_1 = require("../../contexts/actionContext");
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const react_bootstrap_table2_overlay_1 = __importDefault(require("react-bootstrap-table2-overlay"));
const react_bootstrap_table2_editor_1 = __importDefault(require("react-bootstrap-table2-editor"));
const react_bootstrap_table2_paginator_1 = __importStar(require("react-bootstrap-table2-paginator"));
require("react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.css");
const ColFormatters_1 = require("../../formatters/ColFormatters");
const util_1 = require("../../util");
const Column_1 = require("../Column");
const lodash_1 = __importStar(require("lodash"));
const DummyField_1 = require("../Cell/components/DummyField");
const data_json_1 = __importDefault(require("../../data/data.json"));
const reactstrap_1 = require("reactstrap");
const BreadCrumbs_1 = require("./components/BreadCrumbs");
require("react-bootstrap-table-next/dist/react-bootstrap-table2.css");
require("../../super-table.css");
require("sweetalert2/src/sweetalert2.scss");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const toaster_1 = require("../common/toaster");
const HeaderColumnFormatter_1 = require("../../formatters/HeaderColumnFormatter");
const cellEdit_1 = require("./components/cellEdit");
const TableActionContainer_1 = require("./components/TableActionContainer");
let headerBeingResized = null;
let headerColumns = [];
class SuperTable extends react_1.default.Component {
    constructor(props) {
        var _a, _b;
        super(props);
        this.ref = react_1.createRef();
        /**
         *  Get Table data based on the current state.
         */
        this.getData = () => {
            const { superTable: { meta }, filters, pageToken, } = this.state;
            const { superTableCategory, superTableSubCategory } = this.props;
            this.props.superApi("get", {
                ...meta,
                filters,
                pageToken,
                category: superTableCategory,
                subCategory: superTableSubCategory,
            });
        };
        /**
         * Various table handlers passed to other components to handle State change during actions.
         */
        this._tableHandlers = {
            handleSearch: (searchValues) => {
                const table = this.state.superTable;
                this.setState({
                    superTable: { ...table, meta: { ...table.meta, searchValues } },
                    pageToken: undefined,
                }, () => {
                    this.getData();
                });
            },
            handlePagination: (pageSize, direction, token) => {
                const table = this.state.superTable;
                this.setState({
                    superTable: { ...table, meta: { ...table.meta, pageSize } },
                    pageToken: token,
                }, () => {
                    this.getData();
                });
            },
            handleFilter: (filterOption) => {
                const table = this.state.superTable;
                this.setState({
                    superTable: { ...table, meta: { ...table.meta, filterOption } },
                    filters: filterOption.value,
                    pageToken: undefined,
                }, () => {
                    this.getData();
                });
            },
            handleSorting: (sortOption) => {
                const table = this.state.superTable;
                this.setState({
                    superTable: {
                        ...table,
                        meta: { ...table.meta, sortOption },
                    },
                    pageToken: undefined,
                }, () => {
                    this.getData();
                });
            },
            handleRefresh: () => {
                let superTable = Object.assign({}, this.state.superTable);
                superTable = {
                    ...superTable,
                };
                this.setState({ superTable }, () => {
                    this.getData();
                });
            },
            handleToggle: (columns) => {
                const table = this.state.superTable;
                table.columns = columns;
                this.setState({ superTable: table, pageToken: undefined });
            },
            handleGroupsChange: (groups) => {
                const table = this.state.superTable;
                let { meta } = table;
                meta = { ...meta, groups };
                table.meta = meta;
                this.setState({ superTable: table, pageToken: undefined }, () => {
                    this.getData();
                });
            },
        };
        /**
         * Calls the table Context
         */
        this.actionDispatcher = (props) => {
            let _props = props;
            const { creator: { row, column } = {} } = props;
            if (_props.api) {
                _props.api = util_1.convertSerializedIntoJS(_props.api, row, column);
            }
            if (_props.events) {
                _props.events = util_1.isSerializedFunction(_props.events)
                    ? util_1.deSerialiseFunction(props.events || "")(row, column)
                    : _props.events;
            }
            if (_props.prompt) {
                const prompt = util_1.isSerializedFunction(_props.prompt)
                    ? util_1.deSerialiseFunction(_props.prompt || "")(row, column)
                    : _props.prompt;
                sweetalert2_1.default.fire({
                    title: prompt.title,
                    text: prompt.description,
                    showCancelButton: true,
                    backdrop: true,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.tableContext(_props);
                    }
                });
            }
            else {
                this.tableContext(_props);
            }
        };
        this.updateMeta = (value) => {
            const { superTable } = this.state;
            const { meta } = superTable;
            const metaUpdated = { ...meta, ...value };
            this.setState({ superTable: { ...superTable, meta: metaUpdated } }, () => this.getData());
        };
        /**
         * Table Context caller all the action are handled by this tableContext and move to other handlers.
         */
        this.tableContext = (props) => {
            switch (props.action) {
                case "api":
                    return this.apiAction(props);
                case "event":
                    return this.eventCaller(props);
                case "modal":
                    return this.modalCaller(props);
                case "window":
                    return this.windowAction(props);
                default:
                    alert("default action");
            }
        };
        /**
         * Updates the particular row with given properties and replace that row with existing row in table data.
         */
        this.updateData = (rowData, properties) => {
            if (!rowData)
                return;
            let { editData } = this.state;
            const rowIndex = editData.findIndex((row) => row._id === rowData._id);
            editData[rowIndex] = { ...rowData, ...properties };
            this.setState({ editData });
        };
        /**
         * Open new window on action performed
         *
         */
        this.windowAction = (props) => {
            const { url = Column_1.basicFun, creator: { row, column: col } = {} } = props;
            const getUrl = util_1.deSerialiseFunction(url)(row, col);
            getUrl && window.open(`${window.location.origin}/${getUrl}`);
        };
        /**
         * Dispatches and API action with ContextProps and update the table Data.
         */
        this.apiAction = (props) => {
            var _a;
            const { category, subCategory, creator, successMessage = "Success", errorMessage = "Failed", } = props;
            this.updateData(creator === null || creator === void 0 ? void 0 : creator.row, { loading: (_a = creator === null || creator === void 0 ? void 0 : creator.column) === null || _a === void 0 ? void 0 : _a.id }); // to set loading for a column
            this.apiCaller(props)
                .then((res) => {
                this.props.notify
                    ? this.props.notify({ type: "success", message: successMessage })
                    : toaster_1.notify({ type: "success", message: successMessage });
                this.updateData(creator === null || creator === void 0 ? void 0 : creator.row, { service: "EC2" }); //
            })
                .catch((err) => {
                // toast(errorMessage, { type: "error" });
                this.props.notify
                    ? this.props.notify({
                        type: "error",
                        message: err.errorCode === 429 ? err.message : errorMessage,
                    })
                    : toaster_1.notify({ type: "error", message: errorMessage });
                console.error(err);
            })
                .finally(() => {
                this.updateData(creator === null || creator === void 0 ? void 0 : creator.row, {
                    loading: undefined,
                });
                // refresh table after completing api actions
                this.getData();
            });
        };
        /**
         * Calls super-api for actions , by passing context props.
         */
        this.apiCaller = async (options) => {
            const { tcApi } = this.props;
            if (tcApi && options.api) {
                //
                const { params, creator: { row, column: col } = {} } = options;
                // console.log(params);
                const constructParams = util_1.convertSerializedIntoJS(params, row, col);
                // console.log(constructParams, options);
                return tcApi[options.api].apply(tcApi, constructParams);
            }
            else {
                return this.props.superApi("action", options);
            }
        };
        /**
         * Generate a url from table context props
         */
        this.generateApiUrl = (resource = types_1.ContextCategory.NONE, resourceAction, props) => {
            return `BASE_API_URL/${resource}/${resourceAction}`;
        };
        /**
         * Call an event based on the context props
         * @todo
         * Implementation of events from the Table UI
         */
        this.eventCaller = ({ event, events, params }) => {
            if (event && params) {
                this.dispatchEvent(event, params);
            }
            if (events === null || events === void 0 ? void 0 : events.length) {
                events.forEach(({ name, params }) => this.dispatchEvent(name, params));
            }
        };
        this.dispatchEvent = (name, params) => {
            const { onRegionAndCredentialsChange } = this.props;
            switch (name) {
                case types_1.Events.ACCOUNT_CHANGE:
                    return (onRegionAndCredentialsChange &&
                        onRegionAndCredentialsChange("account", params));
                case types_1.Events.REGION_CHANGE:
                    return (onRegionAndCredentialsChange &&
                        onRegionAndCredentialsChange("region", params));
                case types_1.Events.FILTER_CHANGE:
                    return this.props.onFilterChange && this.props.onFilterChange(params);
                case types_1.Events.SEARCH_CHANGE:
                    return (this.props.onSearchChange &&
                        this.props.onSearchChange(params.searchValues));
                case types_1.Events.PARAM_CHANGE:
                    return this.updateMeta({ ...params });
                default:
                    break;
            }
        };
        /**
         *
         * Opens a modal through context passed by any component from table.
         * Save modal type into the current state of super-table
         */
        this.modalCaller = ({ action, creator, modal }) => {
            this.setState({ tableModal: { modal, open: true }, creator });
        };
        /**
         * Hide the currently open modal  and remove it from state.
         */
        this.onHideModal = () => {
            this.setState({ tableModal: { open: false } });
        };
        /**
         * Add a event listener and setup necessary initialization;
         * @param e
         */
        this.onMouseDown = (e) => {
            var _a;
            e.persist();
            window.addEventListener("mousemove", this.onMouseMove);
            window.addEventListener("mouseup", this.onMouseUp);
            // @ts-ignore
            headerBeingResized = (_a = e.target) === null || _a === void 0 ? void 0 : _a.parentNode;
            document.querySelectorAll(`#${this.props.tableId} th`).forEach((header) => {
                headerColumns.push({
                    header: header,
                    size: header.clientWidth + "px",
                });
                headerBeingResized &&
                    headerBeingResized.classList.add("header--being-resized");
            });
        };
        /**
         * Remove mouse move and mouse-up listener on the window to be reset/re-used by any other component afterwards.
         * Unset headerBeingResized element to make it free.
         * Empties the headerColumns to be reused next time onMouseDown is used.
         * @param {MouseEvent} e
         */
        this.onMouseUp = (e) => {
            if (headerBeingResized) {
                headerBeingResized.classList.remove("header--being-resized");
                headerBeingResized = null;
            }
            headerColumns = [];
            window.removeEventListener("mousemove", this.onMouseMove);
            window.removeEventListener("mouseup", this.onMouseUp);
        };
        /**
         * A mouse move event triggered after resize handle is clicked (mouseDown) and dragged ( MouseMove) before mouseUp
         * @param {MouseEvent} e
         */
        this.onMouseMove = (e) => {
            requestAnimationFrame(() => {
                const min = 150;
                const { tableId } = this.props;
                // Do nothing if header to resize is null.
                if (!headerBeingResized)
                    return;
                let horizontalScrollOffset = document.documentElement.scrollLeft;
                const width = horizontalScrollOffset + e.clientX - headerBeingResized.offsetLeft;
                const column = headerColumns.find(({ header }) => header === headerBeingResized);
                const columnIndex = headerColumns.findIndex(({ header }) => header === headerBeingResized);
                if (column) {
                    column.size = Math.max(min, width) + "px"; // Enforce our minimum
                    headerColumns[columnIndex] = column;
                    // get table header row
                    const tableHeaderRow = document.querySelector(`#${tableId} thead tr`);
                    if (!tableHeaderRow)
                        return;
                    // for each header in row replace with the changed header/
                    headerColumns.forEach((column) => {
                        let xHeader = column.header;
                        xHeader.style.width = column.size;
                        // replace table row child header with the changed header.
                        tableHeaderRow.replaceChild(xHeader, column.header);
                    });
                }
            });
        };
        /**
         * Get Columns in a format that is accepted by the react-bootstrap-table-next. Backend mapping and serialised functions are calculated here.
         * All the formatter are provided with extra data they need according to super-table cell renderers.
         *
         */
        this.getColumns = () => {
            const { superTable, showDummy } = this.state;
            const { tableId } = this.props;
            const { columns } = superTable;
            if (!columns || !columns.length) {
                return [];
            }
            return columns.map((col, colIndex) => {
                const { headerAlign, style, id, cell, hidden, name, action, loader, styleClasses = Column_1.basicFun, sort, headerClass = Column_1.basicFun, edit, waiting, align, editable, } = col;
                const modifiedColumns = {
                    sortValue: undefined,
                    dataField: id,
                    text: name,
                    headerFormatter: showDummy
                        ? () => react_1.default.createElement(DummyField_1.DummyField, null)
                        : HeaderColumnFormatter_1.headerColumnFormatter,
                    headerAlign: headerAlign || align || "left",
                    align: align,
                    headerStyle: col.headerStyle,
                    headerClasses: (column, colIndex1) => util_1.deSerialiseFunction(headerClass)(column, colIndex1) || "",
                    formatter: ColFormatters_1.colFormatter,
                    formatExtraData: {
                        type: cell === null || cell === void 0 ? void 0 : cell.type,
                        value: cell === null || cell === void 0 ? void 0 : cell.value,
                        action,
                        col,
                        colIndex,
                        table: superTable,
                        onAction: this.actionDispatcher,
                    },
                    hidden,
                    sort: typeof sort === "undefined" ? true : sort,
                    style: { ...style },
                    editable: typeof editable === "undefined" ? false : editable,
                    editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex) => cellEdit_1.cellEditor(col, editorProps, value, row, column, rowIndex, columnIndex),
                };
                if (col.sortValue) {
                    modifiedColumns.sortValue = (cell, row) => util_1.convertSerializedIntoJS(col.sortValue, row, col);
                }
                return modifiedColumns;
            });
        };
        /**
         * this function auto fetch data if there is any loading data in the table.
         * default re-fetch interval is 5sec.
         */
        this.reFetch = () => {
            const data = this.state.superTable.data;
            if (!data)
                return;
            if (data.find((x) => Boolean(x.loading))) {
                this.getData();
            }
            const reFetchTimeout = setTimeout(() => {
                this.reFetch();
            }, 5000);
        };
        this.overlay = () => react_bootstrap_table2_overlay_1.default({
            spinner: this.props.spinner || (react_1.default.createElement("span", { className: "mx-auto" },
                react_1.default.createElement("i", { className: "fa fa-spinner text-primary fa-spin" }))),
            styles: {
                spinner: {},
                overlay: (base) => ({
                    ...base,
                    background: "rgba(255, 255, 255, 0)",
                }),
            },
        });
        this.selectRows = (row, isSelected, rowIndex) => {
            let { selectedRows } = this.state;
            const isRowPresent = selectedRows.findIndex((x) => x._id === row._id);
            if (isRowPresent !== -1) {
                selectedRows = selectedRows
                    .slice(0, isRowPresent)
                    .concat(selectedRows.slice(isRowPresent + 1));
            }
            else {
                selectedRows.push(row);
            }
            this.setState({ selectedRows });
        };
        this.onSelectAll = (isSelect, rows) => {
            if (isSelect) {
                this.setState({ selectedRows: rows });
            }
            else {
                this.setState({ selectedRows: [] });
            }
        };
        this.tableRowSelection = () => {
            const { superTable, selectedRows } = this.state;
            const { selectAllRow, selectRowMulti, selectRow } = superTable.controls || {};
            if (!selectRow) {
                return { mode: "radio", hideSelectColumn: true };
            }
            return {
                mode: selectRowMulti ? "checkbox" : "radio",
                onSelect: this.selectRows,
                onSelectAll: this.onSelectAll,
            };
        };
        this.onCellEdit = (cellEdit) => {
            const { rowId, newValue, dataField } = cellEdit;
            const { editData } = this.state;
            const data = lodash_1.default.cloneDeep(editData);
            const row = data[Number(rowId)];
            if (row) {
                row[dataField] = newValue;
                data[Number(rowId)] = row;
            }
            this.setState({ editData: data, isEdit: true }, () => {
                console.log(this.state.superTable.data, this.state.editData);
            });
        };
        this.editHandlers = {
            onSave: () => {
                console.log("Saving Edits");
            },
            onCancel: () => {
                var _a;
                this.setState({
                    isEdit: false,
                    editData: ((_a = this.props.superTableData) === null || _a === void 0 ? void 0 : _a.data) || [],
                }, () => {
                    console.log(this.state.editData);
                });
            },
        };
        this.cellEdit = () => {
            return react_bootstrap_table2_editor_1.default({
                mode: "dbclick",
                blurToSave: true,
            });
        };
        this.tableChangeHandler = (type, newState) => {
            switch (type) {
                case "cellEdit":
                    return this.onCellEdit(newState.cellEdit);
            }
        };
        this.state = {
            selectedRows: [],
            filters: {},
            superTable: this.props.superTableData || data_json_1.default,
            tableModal: { modal: undefined, open: false },
            pageToken: undefined,
            showDummy: true,
            editData: lodash_1.default.cloneDeep((_a = this.props.superTableData) === null || _a === void 0 ? void 0 : _a.data) || [],
            isEdit: false,
            pagination: {
                page: 1,
                sizePerPage: 20,
                totalSize: ((_b = this.props.superTableData) === null || _b === void 0 ? void 0 : _b.data.length) || 0,
            },
        };
    }
    componentDidMount() {
        var _a, _b;
        this.setState({
            superTable: this.props.superTableData || data_json_1.default,
            tableModal: { modal: undefined, open: false },
            showDummy: !Boolean(this.props.superTableData),
            editData: lodash_1.default.cloneDeep((_a = this.props.superTableData) === null || _a === void 0 ? void 0 : _a.data) || [],
            isEdit: false,
            pagination: {
                page: 1,
                sizePerPage: 20,
                totalSize: ((_b = this.props.superTableData) === null || _b === void 0 ? void 0 : _b.data.length) || 0,
            },
        });
        this.state.reFetchTimeout && clearTimeout(this.state.reFetchTimeout);
        this.setState({ reFetchTimeout: undefined });
        this.reFetch();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        var _a;
        if (!lodash_1.isEqual(prevProps.superTableData, this.props.superTableData)) {
            const { superTableData = data_json_1.default, } = this.props;
            this.setState({
                superTable: {
                    ...superTableData,
                    meta: { ...this.state.superTable.meta, ...superTableData.meta },
                },
                showDummy: !Boolean(superTableData),
                editData: (superTableData === null || superTableData === void 0 ? void 0 : superTableData.data) || [],
                pagination: {
                    page: 1,
                    sizePerPage: (superTableData === null || superTableData === void 0 ? void 0 : superTableData.meta.pageSize) || 25,
                    totalSize: ((_a = this.props.superTableData) === null || _a === void 0 ? void 0 : _a.data.length) || 0,
                },
            }, () => { });
        }
        if (!lodash_1.isEqual(this.state.superTable.data, prevState.superTable.data)) {
            this.state.reFetchTimeout && this.reFetch();
        }
    }
    render() {
        const { superTable, tableModal, creator, showDummy, selectedRows, editData, isEdit, } = this.state;
        const { loading, modalRenderer, regions, credentials, overflow, tableId, resizable, } = this.props;
        const modalProps = {
            credentials,
            regions,
            modal: tableModal.modal,
            onCancel: this.onHideModal,
            onHide: this.onHideModal,
            onSave: this.onHideModal,
            show: tableModal.open,
            creator: creator,
            handlers: this._tableHandlers,
        };
        const contextValue = {
            table: superTable,
            actionDispatcher: this.actionDispatcher,
            cellResizer: this.onMouseDown,
            superApi: this.props.superApi,
            superTableCategory: this.props.superTableCategory,
            superTableSubCategory: this.props.superTableSubCategory,
            searchApi: this.props.searchApi,
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(reactstrap_1.Row, { className: "mb-3" },
                react_1.default.createElement(reactstrap_1.Col, { md: 12, className: "d-flex align-items-center" }, superTable.tableBreadCrumbs && (react_1.default.createElement(BreadCrumbs_1.BreadCrumbs, { tableBreadCrumbs: superTable.tableBreadCrumbs || [], onSelect: this.actionDispatcher })))),
            react_1.default.createElement(actionContext_1.ActionContextCreator.Provider, { value: contextValue },
                modalRenderer && tableModal.modal && creator && (react_1.default.createElement("div", { className: "position-absolute w-100 h-100" }, modalRenderer(modalProps))),
                react_1.default.createElement(react_bootstrap_table2_paginator_1.PaginationProvider, { pagination: react_bootstrap_table2_paginator_1.default({
                        custom: true,
                        ...this.state.pagination,
                    }) }, ({ paginationProps, paginationTableProps }) => (react_1.default.createElement("div", null,
                    react_1.default.createElement(TableActionContainer_1.TableActionContainer, { selectedRows: selectedRows, actionDispatcher: this.actionDispatcher, dummy: showDummy, tableHandlers: this._tableHandlers, table: superTable, edit: isEdit, editHandlers: this.editHandlers, internalPaginationProps: paginationProps }),
                    react_1.default.createElement(react_bootstrap_table_next_1.default, Object.assign({ ref: this.ref, id: tableId, wrapperClasses: `${overflow ? "overflow-scroll" : ""} ${resizable ? "resize-table" : ""}`, 
                        // @ts-ignore
                        loading: loading, selectRow: this.tableRowSelection(), hover: true, bootstrap4: true, overlay: this.overlay(), noDataIndication: "No Data to render", classes: "super-table", keyField: "_id", bordered: false, cellEdit: this.cellEdit(), data: editData, columns: this.getColumns(), remote: {
                            cellEdit: true,
                        }, onTableChange: this.tableChangeHandler }, paginationTableProps))))))));
    }
}
exports.SuperTable = SuperTable;
//# sourceMappingURL=index.js.map